export default __webpack_public_path__ + "static/media/theCardGame1Low.cec474df.jpg";